(function () {
  let clickCleanup = null;

  const initAnnBar = () => {
    const annBar = document.querySelector(".announcement-section");

    if (clickCleanup) {
      clickCleanup();
      clickCleanup = null;
    }

    let intersectionObserver;
    let resizeObserver;
    let lastRatio = 1;

    const updateHeight = (intersectionRatio = 1) => {
      const annBarHeight = annBar?.getBoundingClientRect().height || 0;
      const effectiveHeight = (annBarHeight * intersectionRatio).toFixed(2);
      document.documentElement.style.setProperty(
        "--ann-height",
        `${effectiveHeight}px`
      );
    };

    const createObservers = () => {
      if (intersectionObserver) intersectionObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();

      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updateHeight(entry.intersectionRatio);
              lastRatio = entry.intersectionRatio;
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
              lastRatio = 0;
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      resizeObserver = new ResizeObserver(() => {
        updateHeight(lastRatio);
      });

      if (annBar) intersectionObserver.observe(annBar);
      if (annBar) resizeObserver.observe(annBar);
    };

    createObservers();

    const overlayLink = annBar?.querySelector(
      ".announcement-bar__overlay-link"
    );
    if (overlayLink && annBar) {
      const handleBarClick = (e) => {
        if (e.target.closest(".announcement-bar__overlay-link")) return;
        const clickedLink = e.target.closest("a");
        if (clickedLink && clickedLink !== overlayLink) return;
        if (!overlayLink.href) return;
        if (overlayLink.target === "_blank") {
          window.open(overlayLink.href, "_blank", "noopener,noreferrer");
        } else {
          window.location.href = overlayLink.href;
        }
      };
      annBar.addEventListener("click", handleBarClick);
      clickCleanup = () => annBar.removeEventListener("click", handleBarClick);
    }
  };

  initAnnBar();

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);
})();
